<template>
  <div class="p-mypage_upload__file">
      <upload v-for="index in nums" :key="index" :multiple="multiple"></upload>
<!--      <p class="p-mypage_upload__file__text">-->
<!--        ポートフォリオなど複数ファイルがある場合は「さらにファイル追加ボタン」を押して追加お願いします。-->
<!--      </p>-->
<!--      <button type="button" class="p-mypage_upload__file__add center">+ さらにファイル追加</button>-->
    </div>
</template>

<script>
import Form from "@/utils/Form";
import Upload from '@/components/MyPage/Upload'

export default {
  props: {
    isMobile : {
      type: Boolean,
      default: false,
      required: false,
    },
    multiple: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    Upload
  },
  data() {
    return {
      nums: 1
    }
  },
  methods: {
    add() {
      this.nums++;
    }
  },
  mounted() {
  },
  computed: {
  },
  created() {
  },
}
</script>
